import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

export const titleResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot
) => {
  const title = inject(Title);
  const translate = inject(TranslateService);
  const key = route.data['title'];

  if (!key) return '';

  const translatedTitle = translate.instant(key);
  title.setTitle(translatedTitle);

  return translatedTitle;
};
